/** @jsxImportSource davaux/client */
import { reactive } from 'davaux'
import { createSignal } from 'davaux/client'

function Notification({
  title,
  message = '',
  color = 'blue',
  visible: initialVisible = true,
  withCloseButton = true,
  autoClose = 0,
  icon,
}: {
  title?: string
  message?: string
  color?: string
  visible?: boolean
  withCloseButton?: boolean
  autoClose?: number
  icon?: string
}) {
  const [visible, setVisible] = createSignal(initialVisible)

  if (autoClose > 0) {
    setTimeout(() => setVisible(false), autoClose)
  }

  return (
    <div
      class='dv-notification'
      data-color={color}
      data-visible={() => visible() || undefined}
      role='alert'
      aria-live='polite'
      aria-atomic='true'
    >
      {icon && <div class='dv-notification-icon' innerHTML={icon} />}
      <div class='dv-notification-body'>
        {title && <div class='dv-notification-title'>{title}</div>}
        <div class='dv-notification-message'>{message}</div>
      </div>
      {withCloseButton && (
        <button
          type='button'
          class='dv-notification-close'
          onClick={() => setVisible(false)}
          aria-label='Dismiss notification'
        >
          ×
        </button>
      )}
    </div>
  )
}

export default reactive(Notification)
